import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import BidListComponent from './BidListComponent';
import TopCardAuctionSummaryComponent from './TopCardAuctionSummaryComponent';
import Web2BidComponents from '../../BidComponents/Web2BidComponents';
import LoginButtonsComponent from './LoginButtonsComponent';
import PerksList from '../PerksList';
import PerkWinOverlay from '../../PerkComponents/PerkWinOverlay';
import BidButtonHandler from './BidButtonHandler';
import twitch from '../../../assets/twitch.svg';
import opensea from '../../../assets/opensea.svg';
import banner_glipbox from '../../../assets/banner_glipbox.png';
import banner_glipbox_mobile from '../../../assets/banner_glipbox_mobile.png';
import eventBus from '../../../utils/globalPubSub';
import { getLoginInformation,
         getPaymentInformation
} from '../../../utils/loginHelper';
import { loginToTwitch } from "../../../utils/loginHelper";
import {
    useHistory,
  } from "react-router-dom/cjs/react-router-dom.min";
import './hypnotizing-border.css'
import { fethchGlipBox } from '../../../utils/backendUtils';

const Creator = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #FFFFFF;

  opacity: 0.4;
  margin-top: 8px;
  margin-bottom: 12px;
`;


const TableHeader = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #FFFFFF;

  opacity: 0.45;
`;


const PerkTitle = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  margin-top: 35px;
  margin-bottom: 14px;
`;

const Title = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 90.1%;
  /* or 56px */

  display: flex;
  align-items: center;

  color: #FFFFFF;
`;



const ConnectButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  width: 367px;
  height: 51px;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 12px;
  background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
  color: #fff;
`

const ConnectButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  border-radius: 12px;
`

const Link = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #FFFFFF;
  opacity: 0.4;
  margin-top: 16px;
`;

const SubTitle = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Tags = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 9px;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    margin-left: 16px;
    display: flex;
    @media only screen and (max-device-width: 480px) {
        margin-right: 16px;
        margin-left: 0px;
        margin-top: 16px;
    }

`;

const UserName = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 90.1%;
    /* or 32px */

    display: flex;
    align-items: center;

    color: #FFFFFF;
`;


const Mobile = styled.div`
  display: none;
  background: #000;
  padding: 26px;
  
  @media only screen and (max-device-width: 480px) {
  display: flex;
  /* height: 96vh; */
  flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
    /* height: 100%; */
    margin-top: 40px;
    /* overflow: hidden; */
  }
`;

const MysteryBoxTitle = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    display: flex;
    align-items: center;

    color: #000000;
`;

const MysteryBoxTimer = styled.span`    
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;

    color: #000000;
    margin-top: 18px;
`;

const ClaimButton = styled.span`    
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;

    color: #000000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 16px;
    width: 122px;
    height: 45px;
    background: #FFFFFF;
    border-radius: 12px;
`;


export default function TopCardComponent(props){

    
    const [connected, setIsConnected] = useState(false);
    const [user, setUser] = useState({});
    const [glipbox, setGlipbox] = useState();
    const [openBox, setOpenBox] = useState();
    const [perkWinModalOpen, setPerkWinModalOpen] = useState(false);
    const history = useHistory();
    
    // Fetch data for remaing glipboxes
    useEffect(() => {
        const fetchApi = async () => {
            const glipboxData = await fethchGlipBox(props.username);
            console.log('glipboxdata==============', glipboxData)
            if(glipboxData.success)
                setGlipbox(glipboxData);
        };

        fetchApi();
    }, []);

    const handleLogin = (loginDetails)=>{
        setIsConnected(true);
        setUser(loginDetails.user);
    }
    
    const handleConnectTwitchClicked = ()=>{
	loginToTwitch()
    }
    
    const handleLogout = ()=> {
        setIsConnected(false);
        setUser({});
    }
    
    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        })
        return ()=>{
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);


    const navigateToCreatorProfile = () => {
        const username = props.username;
        history.push(`/u/${username}`);
    }
    
    return (
        <>
            <Mobile>
                <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', width: '100%', }}>
                    <div style={{
                        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 69.2%, rgba(0, 0, 0, 0.8) 100%)',
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        maxWidth: 930
                    }}
                    >
                        <UserName onClick={()=>{
                            navigateToCreatorProfile();
                            window.analytics.track('creator_username_clicked', {
                                type: 'web',
                                from: 'TopCard',
                                location: window.location.href
                            });
                        }}>@{props.username}
                        </UserName>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: 28}}>
                            
                            <Tags  className="hover" onClick={() => {window.location.href = `https://twitch.tv/${props.username}`;}}>
                                <img src={twitch} style={{marginRight: 8}} />
                                {props.username}
                            </Tags>
                            {props.item.opensea && <Tags className="hover" onClick={() => {console.log(props.item.opensea); window.location.href = props.item.opensea;}}>
                                <img src={opensea} style={{marginRight: 8}} />
                                Opensea
                            </Tags>}
                        </div>
                        <div className="hypnotize" style={{
                            padding: 2, 
                            margin: 0,
                            width: 'fit-content',
                            height: 'fit-content',
                            margin: '0px -25px 0px',
                            display: 'flex'
                        }}>
                            <video 
                                style={{
                                    maxHeight: 735,
                                    width: '100%',                            
                                    height: '100%',                            
                                }}
                                controls
                                loop
                            
                                disablePictureInPicture
                                controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                src={props.item.videoUri}
                            />
                        </div>
                        {false && glipbox && <div style={{
                            marginTop: 2,
                            background: `url('${banner_glipbox_mobile}')`,
                            backgroundSize: `100% 100%`,
                            borderRadius: 0,
                            display: 'flex',
                            justifyContent: 'flex-start',
                            padding: 25,
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            margin: '0px -25px 25px',
                            }}>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <MysteryBoxTitle>{props.username}'s Mystery <br></br>Glipbox Claiming</MysteryBoxTitle>
                                <MysteryBoxTimer>{glipbox.data.minted}/{glipbox.data.supply} claimed</MysteryBoxTimer>
                            </div>
                            <ClaimButton style={{marginTop: 25}} onClick={() => history.push(`/claim/glipbox/${props.username}`)} className="hover">Claim Now</ClaimButton>
                        </div>}                   
                        <br></br>
                        {false && <div style={{display: 'flex', marginTop: 26}}>
                            {props.item.etherscan && <Link href={props.item.etherscan} target="_blank">Etherscan Link</Link>}
                            {props.item.etherscan && <Link style={{marginLeft: 32}} href={props.item.opensea} target="_blank">OpenSea Link</Link>}
                        </div>}
                        {/* <Creator>Created by</Creator> */}

                        <div style={{borderBottom: '0px dashed rgba(255, 255, 255, .41)'}}>
                            <Title>#{props.item.serial}</Title>
                            {/* <SubTitle>Etherscan link</SubTitle> */}
                            {!props.ended ? <>
                                <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12, marginTop: 28, padding: 18}}>
                                    <TopCardAuctionSummaryComponent
                                        item={props.item}
                                    >
                                    </TopCardAuctionSummaryComponent>
                                    {!connected && (
                                        <div style={{marginTop:16}}>
                                            <LoginButtonsComponent
                                            >
                                            </LoginButtonsComponent>
                                        </div>
                                    )}
                                    {connected && (
                                        <BidButtonHandler
                                            item={props.item}
                                            bids={props.bids}
                                        >                                    
                                        </BidButtonHandler>
                                    )}
                                </div>
                            </>
                            :
                             <>
                                 {(props.item.mintedPrice) && <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12, marginTop: 28}}>
                                     <div style={{background: 'rgba(255,255,255,0.04)', padding: 18, }}>
                                         <SubTitle>Sold for</SubTitle>
                                         <Title style={{fontSize: 24, marginTop: 4}}>{props.item.mintedPrice} USD</Title>
                                     </div>
                                     {/* TODO INGAMMA HELP */}
                                     {/* {user.username == props.username && <div style={{display: 'flex', justifyContent: 'space-between', padding: 18}}> */}
                                     {true && <div style={{display: 'flex', justifyContent: 'space-between', padding: 18}}>
                                         {/* <ConnectButtonDiv onClick={() => history.push('/perks/claim/')} style={{borderRadius: 12, color: '#000', fontWeight: 'bold', flex: 4, textAlign: 'center'}}>CLAIM NFT PERKS</ConnectButtonDiv> */}
                                         <ConnectButtonDiv onClick={() => {setOpenBox(props.item); setPerkWinModalOpen(true)}} style={{borderRadius: 12, color: '#fff', fontWeight: 'bold', flex: 4, textAlign: 'center'}}>OPEN LOOTBOX</ConnectButtonDiv>
                                         {/* <Tags className="hover" style={{fontWeight: 'bold', flex: 1, justifyContent: 'center'}}>TRANSFER</Tags> */}
                                     </div>}
                                 </div>}
                             </>
                            }
                            
                            <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12}}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginTop: 25,
                                    padding: '14px 18px', 
                                    background: '#141414',
                                    borderTopLeftRadius: 14,
                                    borderTopRightRadius: 14,
                                    background: 'rgba(255, 255, 255, 0.04)'
                                }}>
                                    <TableHeader>Bid</TableHeader>
                                    <TableHeader>Bidder</TableHeader>
                                    <TableHeader>Time</TableHeader>
                                </div>
                                <div className='hide-scroll-bars' style={{
                                    maxHeight: 450,
                                    minHeight: 180,
                                    overflowY: 'scroll',
                                    paddingBottom: 10
                                }}>
                                    <BidListComponent
                                        bids={props.bids}
                                    >
                                    </BidListComponent>
                                    <div syle={{boxShadow: 'black 0px -40px 50px 10px', zIndex: 2, width: '100%'}}></div>
                                </div>   
                            </div>
                            
                        </div>
                        
                        <PerkTitle>NFT HOLDER PERKS</PerkTitle>
                        <div style={{display: 'flex', flexWrap: 'wrap', marginLeft: -13, marginRight: -13}}>                        
                            <PerksList isStatic={true} setActive={() => {}} active={0} perksData={props.perks} />
                        </div>
                    </div>
                    
                    
                </div>
            </Mobile>
            <Desktop>  
                <div style={{display: 'flex', justifyContent: 'space-between', justifyContent: 'row', width: '100%', }}>
                    <div style={{
                        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 69.2%, rgba(0, 0, 0, 0.8) 100%)',
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        maxWidth: 930
                    }}
                    >
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: 28}}>
                            <UserName onClick={()=>{
                                navigateToCreatorProfile();
                                window.analytics.track('creator_username_clicked', {
                                    type: 'web',
                                    from: 'TopCard',
                                    location: window.location.href
                                });
                            }}>@{props.username}
                            </UserName>
                            <Tags  className="hover" onClick={() => {window.location.href = `https://twitch.tv/${props.username}`;}}>
                                <img src={twitch} style={{marginRight: 8}} />
                                {props.username}
                            </Tags>
                            <Tags className="hover" onClick={() => {console.log(props.item.opensea); window.location.href = props.item.opensea;}}>
                                <img src={opensea} style={{marginRight: 8}} />
                                Opensea
                            </Tags>
                        </div>
                        <div className="hypnotize" style={{
                            padding: 2, 
                            margin: 0,
                            width: 'fit-content',
                            height: 'fit-content',
                            display: 'flex'
                        }}>
                            {/* <video
                                autoPlay={true}
                                autoplay
                                style={{maxWidth: 145, flex: 1}}
                                src='https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/draft170_4.mp4'
                                /> */}
                            <video 
                                style={{
                                    maxHeight: 735,
                                    width: '100%',
                                    height: '100%',      
                                    flex: 3                      
                                }}
                                controls
                                loop
                            
                                disablePictureInPicture
                                controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                src={props.item.videoUri}
                            />
                        </div>
                        {false && glipbox && <div style={{
                            marginTop: 24,
                            background: `url('${banner_glipbox}')`,
                            backgroundSize: `100% 100%`,
                            height: 172,
                            width: '100%',
                            borderRadius: 12,
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: 25,
                            alignItems: 'center',
                            }}>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <MysteryBoxTitle>{props.username}'s Mystery <br></br>Glipbox Claiming</MysteryBoxTitle>
                                <MysteryBoxTimer>{glipbox.data.minted}/{glipbox.data.supply} claimed</MysteryBoxTimer>
                            </div>
                            <ClaimButton onClick={() => history.push(`/claim/glipbox/${props.username}`)} className="hover">Claim Now</ClaimButton>
                        </div>}
                        {false && <div style={{display: 'flex', marginTop: 26}}>
                            {props.item.etherscan && <Link href={props.item.etherscan} target="_blank">Etherscan Link</Link>}
                            {props.item.etherscan && <Link style={{marginLeft: 32}} href={props.item.opensea} target="_blank">OpenSea Link</Link>}
                        </div>}
                        {/* <Creator>Created by</Creator> */}
                        <PerkTitle>NFT HOLDER PERKS</PerkTitle>
                        <div style={{display: 'flex', flexWrap: 'wrap', marginLeft: -13, marginRight: -13}}>                        
                            <PerksList isStatic={true} setActive={() => {}} active={0} perksData={props.perks} />
                        </div>
                    </div>
                    
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        width: '100%',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        flexDirection: 'column',
                        marginLeft: 55,              
                        flex: 0.6,
                    }}
                    >
                        <div style={{borderBottom: '0px dashed rgba(255, 255, 255, .41)'}}>
                            <Title>#{props.item.serial}</Title>
                            {/* <SubTitle>Etherscan link</SubTitle> */}
                            {!props.ended ? <>
                                <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12, marginTop: 28, padding: 18}}>
                                    <TopCardAuctionSummaryComponent
                                        item={props.item}
                                    >
                                    </TopCardAuctionSummaryComponent>
                                    {!connected && (
                                        <div style={{marginTop:16}}>
                                            <LoginButtonsComponent
                                            >
                                            </LoginButtonsComponent>
                                        </div>
                                    )}
                                    {connected && (
                                        <BidButtonHandler
                                            item={props.item}
                                            bids={props.bids}
                                        >                                    
                                        </BidButtonHandler>
                                    )}
                                </div>
                            </>
                            :
                             <>
                                 {(props.item.mintedPrice) && <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12, marginTop: 28}}>
                                     <div style={{background: 'rgba(255,255,255,0.04)',padding: 18, }}>
                                         <SubTitle>Sold for</SubTitle>
                                         <Title style={{fontSize: 24, marginTop: 4}}>{props.item.mintedPrice} USD</Title>
                                     </div>
                                     {/* TODO INGAMMA HELP */}
                                     {user.username == props.username && <div style={{display: 'flex', justifyContent: 'space-between', padding: 18}}>
                                     {/* {true && <div style={{display: 'flex', justifyContent: 'space-between', padding: 18}}> */}
                                         {/* <ConnectButtonDiv onClick={() => history.push('/perks/claim/')} style={{borderRadius: 12, color: '#000', fontWeight: 'bold', flex: 4, textAlign: 'center'}}>CLAIM NFT PERKS</ConnectButtonDiv> */}
                                         <ConnectButtonDiv 
                                            onClick={() => {setOpenBox(props.item); setPerkWinModalOpen(true)}}
                                            style={{borderRadius: 12, color: '#fff', fontWeight: 'bold', flex: 4, textAlign: 'center'}}>
                                                OPEN LOOTBOX
                                        </ConnectButtonDiv>
                                         {/* <Tags className="hover" style={{fontWeight: 'bold', flex: 1, justifyContent: 'center'}}>TRANSFER</Tags> */}
                                     </div>}
                                 </div>}
                             </>
                            }
                            
                            <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12}}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginTop: 25,
                                    padding: '14px 18px', 
                                    background: '#141414',
                                    borderTopLeftRadius: 14,
                                    borderTopRightRadius: 14,
                                    background: 'rgba(255, 255, 255, 0.04)'
                                }}>
                                    <TableHeader>Bid</TableHeader>
                                    <TableHeader>Bidder</TableHeader>
                                    <TableHeader>Time</TableHeader>
                                </div>
                                <div className='hide-scroll-bars' style={{
                                    maxHeight: 450,
                                    minHeight: 180,
                                    overflowY: 'scroll',
                                    paddingBottom: 10
                                }}>
                                    <BidListComponent
                                        bids={props.bids}
                                    >
                                    </BidListComponent>
                                    <div syle={{boxShadow: 'black 0px -40px 50px 10px', zIndex: 2, width: '100%'}}></div>
                                </div>   
                            </div>
                            
                        </div>
                        
                        
                    </div>
                </div>
            </Desktop>
            <PerkWinOverlay 
                handleModalCloseEvent={() => setPerkWinModalOpen(false)} 
                isOpen={perkWinModalOpen} 
                item={openBox}
                username={props.username}
                serial={props.item.serial}
            />
        </>
    )
}
